import { fmtTimeWithSeconds } from './formatters';

/**
 * A ÚLTIMA DECISÃO DO ROBÔ no card da disputa (`dispute_sessions.ultimaDecisao`, backend #471).
 *
 * O caso: sessão 163 (Dispensa 133/2026 Divinópolis, 16/10/2026). O robô segurou às 14:59:53 por "melhor posição já
 * alcançada", e a frase existiu só no log do pm2. Na tela, nada separava "segurando de propósito" de "robô morto".
 *
 * ⚠️ O `at` NÃO é o início da decisão. O backend grava na hora quando o motivo muda e, com o MESMO motivo, regrava a
 * cada 60 s (o anti-flood do log), com `at` novo. Por isso a tela diz "às HH:MM:SS" (o último registro), nunca "desde".
 */
export type UltimaDecisao = { acao: 'hold' | 'lance'; motivo: string; codigo: string; grupo: string | null; at: string };

export type DecisaoNoCartao = {
  tom: 'segurando' | 'lancou';
  rotulo: string;
  motivo: string;
  hora: string;
};

export function decisaoDoRobo(session: any): DecisaoNoCartao | null {
  const d = session?.ultimaDecisao;
  if (!d || typeof d !== 'object') return null;
  if (d.acao !== 'hold' && d.acao !== 'lance') return null;
  const motivo = typeof d.motivo === 'string' ? d.motivo.trim() : '';
  if (!motivo) return null;
  const t = typeof d.at === 'string' ? new Date(d.at).getTime() : NaN;
  const grupo = typeof d.grupo === 'string' && d.grupo ? ` (grupo ${d.grupo})` : '';
  return {
    tom: d.acao === 'hold' ? 'segurando' : 'lancou',
    rotulo: d.acao === 'hold' ? `robô segurando${grupo}` : `robô lançou${grupo}`,
    motivo,
    hora: Number.isFinite(t) ? fmtTimeWithSeconds(t) : '—',
  };
}
